import { useContext, useEffect, useState } from "react";
import Header from "../components/Header";
import LanguageContext from "../components/hooks/LanguageContext";
import LanguageSet from "../components/language/LanguageSet";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import LoadingSnip from "../components/LoadingSnip";
import Constants from "../common/Constants";
import { useAuth } from "../providers/AuthProvider";
import { getText } from "../utils/languageUtils";
const API_STUDENT_PROGRESS = `${Constants.BASE_URL}/studentprogress`;

const ShareFeedback = () => {
    const { user, logout: authLogout, authDispatch} = useAuth();
    
    const navigate = useNavigate()
    const { language, translations: translationData } = useContext(LanguageContext);
    const translations = translationData?.share_feedback || {};
    const [selected, setSelected] = useState(null);
    const [feedback, setFeedback] = useState("");
    const [pageData, setPageData] = useState("");
    const [loading, setLoading] = useState(false);

    const [feedbackHistory, setFeedbackHistory] = useState([])

    
    const url = `${Constants.BASE_URL}/feedback`;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            try {
                const formData = new FormData();
                formData.append("program_type", selected);
                formData.append("feedback", feedback);
                formData.append("access_token", user?.token);

                const response = await axios.post(url, formData,
                    {
                        headers: {
                            'x-api-key': 'fc9f4a47-4f7f-41ba-a656-d30e0009d6f0',
                            "Access-Control-Allow-Origin": "*"
                        }
                    }
                );
                handleApiResponse(response.data);
            } catch (error) {
                console.error(error);
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    const handleApiResponse = (data) => {
        if (data.message === "Feedback Submitted Successful") {
            toast.success('Thank You, Feedback submited');
            setSelected(null)
            setFeedback("")
        } else {
            toast.warning(data.message);
        }
    };

    const validate = () => {
        if (!selected) {
            toast.warning('Please select an option.');
            return false;
        }
        if (!feedback) {
            toast.warning('Please provide your feedback.');
            return false;
        }
        return true;
    };

    useEffect(() => {
        setLoading(true)
        const fetchData = async () => {
            let newUrl = `${Constants.BASE_URL}/appfeedback?access_token=${user?.token}`;
            
            try {
                const response = await axios.get(newUrl);
                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                    setPageData(response?.data?.feedback_summary)
                }

                const response2 = await axios.get(`${Constants.BASE_URL}/teacherfeedback?access_token=${user?.token}`);
                if (response2.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                    
                    setFeedbackHistory(response2?.data?.feedback_response)
                    setLoading(false)
                }

                const response3 = await axios.post(`${API_STUDENT_PROGRESS}?access_token=${user?.token}`);
                
                if (response3.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                     const progress = response3.data?.student_summary;
                authDispatch({ type: "SET_PROGRESS", payload: { points: progress.points, progress } });
                    setLoading(false);
                }
            }
            catch (error) {
                console.error(error);
                setLoading(false)
            }
        }
        fetchData();
    }, [])
    
    return (
        <>
            <Header page_title={getText(translations.feedback, language)}  />
            <LanguageSet />
            {loading ?
                (<LoadingSnip />)
                : (
                    <div className="container-fluid px-0">
                        <div className="row justify-content-center">
                            <div className="col-xl-5 col-md-12">
                                <section className="my-3">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="sectionsBox">
                                                    <p className="mb-0 text-center">
                                                        {pageData && getText(pageData.title, language)}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-12 border rounded-1 my-4">
                                                <div style={{ backgroundColor: "rgba(243, 211, 208, 0.40)" }} className="feedback-dicription border-bottom px-2 py-3">
                                                    <p className="mb-0"> {pageData && getText(pageData.description, language)}</p>

                                                </div>
                                                <div className="my-2 p-2">
                                                    <p>{pageData && getText(pageData.program_text, language)}</p>
                                                </div>
                                                <div>
                                                    <form className="single-type" onSubmit={handleSubmit}>

                                                        <label >
                                                            <input
                                                                type="radio"
                                                                name="option"
                                                                value={1}
                                                                checked={selected === 1}
                                                                onChange={() => setSelected(1)}
                                                            />
                                                            <span>
                                                            {pageData && getText(pageData.program_type, language)?.[0]}
                                                            </span>
                                                        </label>

                                                        <label >
                                                            <input
                                                                type="radio"
                                                                name="option"
                                                                value={2}
                                                                checked={selected === 2}
                                                                onChange={() => { setSelected(2) }}
                                                            />
                                                            <span>
                                                            {pageData && getText(pageData.program_type, language)?.[1]}

                                                            </span>
                                                        </label>
                                                        <div className="p-2">
                                                            <textarea
                                                                className="form-control"
                                                                placeholder={getText(translations.add_comments, language)}
                                                                id="floatingTextarea"
                                                                value={feedback}
                                                                onChange={(event) => { setFeedback(event.target.value) }}
                                                            ></textarea>
                                                        </div>
                                                        <div className="feedbackButtons d-flex justify-content-center mb-5 mt-2">
                                                            <button className="d-flex align-items-center gap-2" type="submit"  >
                                                                {getText(translationData?.baseline?.submit, language)}</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                            <ToastContainer
                                                position="top-center"
                                                autoClose={5000}
                                                hideProgressBar={false}
                                                newestOnTop={false}
                                                closeOnClick
                                                rtl={false}
                                                pauseOnFocusLoss
                                                draggable
                                                pauseOnHover
                                                theme="light"
                                            />
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
};

export default ShareFeedback;
